import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActionSheetController, Platform} from '@ionic/angular';
import {Storage} from 'aws-amplify';
//import {FilePicker} from '@robingenz/capacitor-file-picker';
import {DomSanitizer} from '@angular/platform-browser';
import {FilePicker} from "@capawesome/capacitor-file-picker";



@Component({
    selector: 'app-file-picker',
    templateUrl: './file-picker.component.html',
    styleUrls: ['./file-picker.component.scss'],
})
export class FilePickerComponent implements OnInit {


    private logger: any;
    storageOption: any = {};
    photoUrl: string;
    hasPhoto = false;
    uploading = false;
    s3ImageFile: any = null;
    s3ImagePath = '';
    errorMessage: string;

    // @ViewChild('fileButton',{ static: false }) fileButton;
    private imageBlob: Blob;
    public isToUpload = false;
    private region: any;
    private bucket: any;
    private format: string;
    file: any;
    imageToShow: any;

    @Input()
    set storageOptions(storageOptions: any) {
        this.storageOption = Object.assign(this.storageOption, storageOptions);
    }

    @Input() url = '';
    @Input() data = null;
    @Input() baseDirectory;

    @Output()
    picked: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    loaded: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    uploaded: EventEmitter<{}> = new EventEmitter<{}>();
    image: string | SVGImageElement;
    @Input() detail: any;
    @Input() lable: any = '';
    @Input() buttonText: any = 'Scegli foto';
    @Input() s3Image: any;

    constructor(private platform: Platform,
                private sanitizer:DomSanitizer,
                public actionSheetController: ActionSheetController) {


    }

    ngOnInit() {
        
        const x: any = Storage.getPluggable('AWSS3');
        
        this.region = x._config.region;
        this.bucket = x._config.bucket;

        this.loaded.subscribe(val => {
            if (val === undefined) {
                return;
            }
            
            this.image = val;
            this.file = val;
            this.isToUpload = true;
           // this.imageToShow =this.arrayBufferToBase64(val);
        });
        if (!Storage) {
            throw new Error(
                'Storage module not registered on AmplifyService provider',
            );
        }

        this.s3ImagePath = this.baseDirectory + new Date().getUTCMinutes();
    }
    sanitize( url:string ) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

     arrayBufferToBase64( buffer ) {
        var binary = '';
        var bytes = new Uint8Array( buffer );
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        }
        return window.btoa( binary );
    }
    pick(file, source?) {

        if (!file) {
            return;
        }
        if (!this.storageOption.contentType) {
            this.storageOption.contentType = file.type;
        }
        const {name, size, type} = file;
        this.picked.emit(file);

        this.s3ImagePath = `${this.s3ImagePath}/${file.name}`;
        this.s3ImageFile = file;
        
        //  const that = this;
        const reader = new FileReader();
        reader.onloadend = (e) => {
            const target: any = e.target;
            const url = target.result;
            //  
            this.photoUrl = url;
            const blob = new Blob([url]);
            this.imageToShow = URL.createObjectURL(blob);
            this.hasPhoto = true;
            this.loaded.emit(url);
        };
        reader.readAsArrayBuffer(file);
    }

    completeFileUpload(error?: any) {
        if (error) {
            return this._setError(error);
        }
        this.s3ImagePath = '';
        this.photoUrl = null;
        this.s3ImageFile = null;
        this.uploading = false;
    }

    onPhotoError() {
        this.hasPhoto = false;
    }

    onAlertClose() {
        this._setError(null);
    }

    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }

    async uploadFile() {
        this.uploading = true;

        //  Storage.put('', '', {});
        try {
            

            const res = await Storage.put(this.s3ImagePath, this.file, this.storageOption);
            
            this.uploaded.emit(res);
            // @ts-ignore
            return {bucket: this.bucket, region: this.region, key: res.key};
            this.completeFileUpload();
        } catch (e) {
            
            this.completeFileUpload(e);
        }

    }


    deletePhoto() {
        this.image = undefined;
        this.imageToShow = undefined;
        //  this.loaded.emit(null);
    }

    /* async pickImage(sourceType) {
         this.cameraOptions.sourceType = sourceType;
         this.camera.getPicture(this.cameraOptions).then((imageData) => {
             // this.camera.DestinationType.FILE_URI gives file URI saved in local
             // this.camera.DestinationType.DATA_URL gives base64 URI
             
             const filename = imageData.substring(imageData.lastIndexOf('/') + 1);
             const path = imageData.substring(0, imageData.lastIndexOf('/') + 1);
             /!*
                   this.file.readAsDataURL(path, filename).then(res => this.image = res).catch(err => 
             this.image = (window as any).Ionic.WebView.convertFileSrc(imageData);
             /!* 
              let base64Image = 'data:image/jpeg;base64,' + imageData;
              this.image = base64Image;*!/
             this.file.resolveLocalFilesystemUrl(imageData).then((entry: FileEntry) => {

                 //  this.image = entry.fullPath;
                 entry.file(file => {
                     this.readFile(file);

                 }, err => {
                     
                 });
             });

         }, (err) => {
             
             // Handle error
         });
    }
*/
    async firePick() {
        if (this.platform.is('cordova')) {
          //  await this.select();
            const element: HTMLElement = document.querySelector('input[name="filepicker11"]') as HTMLElement;
            element.click();
        } else {
            const element: HTMLElement = document.querySelector('input[name="filepicker11"]') as HTMLElement;
            
            element.click();
        }

    }

    pickFile($event) {
        const file = $event.target.files[0];
        this.pick(file);
    }

    readFile(file: any) {
        const reader = new FileReader();
        reader.onloadend = (e) => {
            
            const target: any = e.target;
            const url = target.result;
            
            this.photoUrl = url;
            this.hasPhoto = true;
            this.loaded.emit(url);
            const imgBlob = new Blob([reader.result], {
                type: file.type,
            });
            this.pick(imgBlob);
        };
        reader.readAsArrayBuffer(file);
    }


    async select() {
        const multiple_selection = false;
        // let ext = [".jpg",".png",".pdf",".jpeg"] // list of extensions
        // let ext = ['MP3', 'ImaGes']; // combination of extensions or category
        // let ext = ["videos", "audios", "images"] // list of all category
        let ext = ['*']; // Allow any file type
        ext = ext.map(v => v.toLowerCase());
        const formData = new FormData();
        
          // import {FilePicker} from '@robingenz/capacitor-file-picker';
         let result = FilePicker.pickFiles({
              multiple: false,
              types: ['image/*', 'application/pdf'],
          });

        



        /*   const selectedFile = await FileSelector.fileSelector({
               multiple_selection,
               ext,
           });
           if (this.platform.is('android')) {
               const paths = JSON.parse(selectedFile.paths);
               const original_names = JSON.parse(selectedFile.original_names);
               const extensions = JSON.parse(selectedFile.extensions);
               for (let index = 0; index < paths.length; index++) {
                   const file = await fetch(paths[index]).then((r) => r.blob());
                   formData.append('myfile[]', file, original_names[index] + extensions[index]);
               }
           } else if (this.platform.is('ios')) {
               for (let index = 0; index < selectedFile.paths.length; index++) {
                   const file = await fetch(selectedFile.paths[index]).then((r) => r.blob());
                   formData.append('myfile[]', file, selectedFile.original_names[index] + selectedFile.extensions[index]);
               }
           } else {
               FileSelector.addListener('onFilesSelected', (data: FileList) => {
                   this.file = data;
                   
               });
           }*/
    }

}
